import { color, DataItem, Root, Series } from '@amcharts/amcharts5';
import * as am5 from '@amcharts/amcharts5';
import { IColumnSeriesDataItem } from '@amcharts/amcharts5/xy';
import React from 'react';

import EventsModal from 'features/Events/components/EventsChart/EventsModal/EventsModal';
import { eventColours, EventData } from 'features/Events/types/eventData';
import { bullet, circle, toolTip } from 'utils/charts/charts';
import { SHADOW, WHITE } from 'utils/colours';

export const createBullets = (
  series: Series,
  setShowModal: (show: boolean) => void,
  setModalContent: (modal: React.ReactElement) => void
) => {
  series.bullets.push((currentRoot: Root, _: Series, dataItem: DataItem<IColumnSeriesDataItem>) => {
    const eventDataContext = dataItem.dataContext as EventData;
    const date = new Date(eventDataContext.time);
    const time = `${date.getHours()}:${(date.getMinutes() < 10 ? '0' : '') + date.getMinutes()}`;
    const eventType = eventDataContext.event;

    const tooltip = toolTip(currentRoot, {
      getFillFromSprite: false,
      getStrokeFromSprite: false,
      pointerOrientation: 'up',
    });
    tooltip.get('background')?.setAll({
      fill: color(WHITE),
      fillOpacity: 1,
      shadowColor: color(SHADOW),
      shadowBlur: 16,
      shadowOffsetX: 0,
      shadowOffsetY: 4,
      shadowOpacity: 0.25,
    });

    const colour = am5.color(eventColours[eventDataContext.event]);

    const newCircle = circle(currentRoot, {
      fill: colour,
      radius: 4,
      tooltip: tooltip,
      tooltipText: `[${colour}][bold]${eventType}  [#000][bold]·[/]  [#000]Time: [bold]${time}`,
    });

    newCircle.events.on('click', (ev) => {
      setModalContent(<EventsModal {...eventDataContext} />);
      setShowModal(true);
    });

    return bullet(currentRoot, {
      sprite: newCircle,
    });
  });
};
